import React from 'react'
import { useAuthContext } from '../../contexts'

import styled from 'styled-components'
import { Button } from '../../components/Button'
import { Redirect } from 'react-router-dom'

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
`

const Login = () => {
  const { signIn, adminUser } = useAuthContext()

  return adminUser ? (
    <Redirect to="/" />
  ) : (
    <Container>
      <Button
        kind="secondary"
        onClick={signIn}
        disabled={adminUser}
        data-testid="okta-login-button"
      >
        Login
      </Button>
    </Container>
  )
}

export { Login }
